import * as Sentry from "@sentry/react";

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const RELEASE =
  (import.meta.env.VITE_APP_RELEASE as string | undefined) ?? undefined;

let initialized = false;

export function initSentry() {
  if (!DSN || initialized) return;

  Sentry.init({
    dsn: DSN,

    environment: import.meta.env.MODE,
    release: RELEASE,

    // 🚫 No performance tracing
    tracesSampleRate: 0,

    // 🚫 No session replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    integrations: [
      // Prevent duplicate error events (React can double-fire)
      Sentry.dedupeIntegration(),
    ],

    beforeSend(event) {
      // 🧹 Strip request data
      if (event.request?.headers) delete event.request.headers;
      if (event.request?.cookies) delete event.request.cookies;

      // 🧹 Strip user completely (we can reintroduce hashed ID later)
      delete event.user;

      return event;
    },
  });

  // 🔖 Global Farmly tags
  Sentry.setTag("app", "farmly");
  Sentry.setTag("layer", "frontend");
  Sentry.setTag("phase", "host-testing");

  initialized = true;
}

export function captureAppError(
  error: unknown,
  context?: {
    feature?: string;
    action?: string;
    [key: string]: any;
  }
) {
  if (!DSN) return;

  Sentry.withScope((scope) => {
    if (context?.feature) {
      scope.setTag("feature", context.feature);
    }

    if (context?.action) {
      scope.setTag("action", context.action);
    }

    if (context) {
      scope.setContext("app_context", context);
    }

    Sentry.captureException(error);
  });
}
